import { faHandHoldingUsd } from "@fortawesome/free-solid-svg-icons";
import { GSInfoGroup, GSButton } from "golfstatus_react_components";
import React from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { getDateTimeOn } from "../../../helpers/Dates";
import "./tournament-reporting-order-summary.scss";
import { moneyWithCommas } from "../../../helpers/RegexHelper";
import { useSelector } from "react-redux";
import { getPayouts, selectPayouts } from "../../../reducers/reportingSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const TournamentReportingOrderSummary = (props) => {
  const {
    availableFunds,
    // escrow,
    // infoiceTotal,
    // lastPayoutDate,
    netRevenue,
    pendingNetRevenue,
    pendingOrderCount,
    //organizationName,
    payoutTotal,
    refundTotal,
    openInvoiceTotal,
    invoiceCount,
    registrationOrderCount,
    registrationOrderRefundCount,
    // tournamentEndsAt,
    // tournamentStartsAt,
    // tournamentState,
    // tournamentTitle,
    showRequest,
    factorInOpenInvoices,
    hideNetRevenue,
    hidePayouts,
    hideRefunds,
    hideGSProducts,
  } = props;

  const navigate = useNavigate();
  const payouts = useSelector(selectPayouts);

  const dispatch = useDispatch();
  const match = useMatch("/:tournamentID/*");

  useEffect(() => {
    if (match?.params?.tournamentID ?? !hidePayouts) {
      dispatch(getPayouts(match.params.tournamentID));
    }
  }, [dispatch, match?.params?.tournamentID, hidePayouts]);

  const availableFundsSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: "Available Funds",
      },
    ],
  };

  // if factoring in open invoices, we only want to display 0 as the minimum
  let availableAmount = availableFunds;
  if (factorInOpenInvoices) {
    if ((availableAmount - openInvoiceTotal) < 0){
      availableAmount = 0;
    } else {
      availableAmount -= openInvoiceTotal;
    }
  }

  const availableFundsSection2 = {
    sectionItems: [
      {
        type: "marquee no-wrap full-width",
        value: moneyWithCommas(availableAmount),
      },
    ],
  };

  const availableFundsSection3 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: `as of ${getDateTimeOn(new Date())}`,
      },
    ],
  };

  const availableFundsSection4 = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: (
          <GSButton
            type="black"
            buttonIcon={faHandHoldingUsd}
            title="request Payout"
            onClick={() => {
              navigate("payouts/request");
            }}
          />
        ),
      },
    ],
  };

  let availableFundsColumn = {
    fit: "stretch",
    sections: [
      {
        ...availableFundsSection,
      },
      { ...availableFundsSection2 },
      { ...availableFundsSection3 },
    ],
  };

  if (showRequest) {
    availableFundsColumn.sections.push({ ...availableFundsSection4 });
  }

  const netRevenueSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: "Net Revenue",
      },
      {
        type: "primary no-wrap full-width",
        value: moneyWithCommas(netRevenue),
      },
    ],
  };

  const netRevenueSection2 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value:
          registrationOrderCount === 1
            ? `${registrationOrderCount} Order`
            : `${registrationOrderCount} Orders`,
      },
    ],
  };

  const netRevenueColumn = {
    fit: "border",
    sections: [
      {
        ...netRevenueSection,
      },
      { ...netRevenueSection2 },
    ],
  };

  const pendingRevenueSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: "Pending Revenue",
      },
      {
        type: "primary no-wrap full-width",
        value: moneyWithCommas(pendingNetRevenue),
      },
    ],
  };

  const pendingRevenueSection2 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value:
          pendingOrderCount === 1
            ? `${pendingOrderCount} Order`
            : `${pendingOrderCount} Orders`,
      },
    ],
  };

  const pendingRevenueColumn = {
    fit: "border",
    sections: [
      {
        ...pendingRevenueSection,
      },
      { ...pendingRevenueSection2 },
    ],
  };

  const payoutTotalSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: "Paid Out",
      },
      {
        type: "primary no-wrap full-width",
        value: moneyWithCommas(payoutTotal),
      },
    ],
  };

  const payoutTotalSection2 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value:
          payouts?.length === 1
            ? `${payouts?.length ?? 0} Payout`
            : `${payouts?.length ?? 0} Payouts`,
      },
    ],
  };

  const payoutTotalColumn = {
    fit: "border",
    sections: [
      {
        ...payoutTotalSection,
      },
      { ...payoutTotalSection2 },
    ],
  };

  const refundTotalSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: "Refunds",
      },
      {
        type: "primary no-wrap full-width",
        value: moneyWithCommas(refundTotal),
      },
    ],
  };

  const refundTotalSection2 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value:
          registrationOrderRefundCount === 1
            ? `${registrationOrderRefundCount} Refund`
            : `${registrationOrderRefundCount} Refunds`,
      },
    ],
  };

  const refundTotalColumn = {
    fit: "border",
    sections: [
      {
        ...refundTotalSection,
      },
      { ...refundTotalSection2 },
    ],
  };

  const golfstatusInvoiceTotalSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: "GolfStatus Products",
      },
      {
        type: "primary no-wrap full-width",
        value: moneyWithCommas(openInvoiceTotal),
      },
    ],
  };

  const golfstatusInvoiceTotalSection2 = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value:
          invoiceCount === 1
            ? `${invoiceCount} Invoice`
            : `${invoiceCount} Invoices`,
      },
    ],
  };

  const golfstatusInvoiceTotalColumn = {
    fit: "border",
    sections: [
      {
        ...golfstatusInvoiceTotalSection,
      },
      { ...golfstatusInvoiceTotalSection2 },
    ],
  };

  const getGroup = () => {
    let group = [{ ...availableFundsColumn }];
    if (!hideNetRevenue) {
      group.push({ ...netRevenueColumn });
      group.push({ ...pendingRevenueColumn });
    }
    if (!hidePayouts) {
      group.push({ ...payoutTotalColumn });
    }
    if (!hideRefunds) {
      group.push({ ...refundTotalColumn });
    }
    if (!hideGSProducts && invoiceCount >= 1) {
      group.push({ ...golfstatusInvoiceTotalColumn });
    }

    return group;
  };

  return (
    <tournament-reporting-order-summary>
      <GSInfoGroup
        listType="mobile-vertical"
        style={{ overflowX: "auto" }}
        dataGroups={getGroup()}
      ></GSInfoGroup>
    </tournament-reporting-order-summary>
  );
};

export default TournamentReportingOrderSummary;
